/* eslint-disable camelcase */

import React from 'react';
import PureComponent from 'react-pure-render/component';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { push } from 'redux-router';
import { loadEventForEdit, setHeader, resetEventConflictChecks, setFlashMessage, removeFlashMessage } from 'actions';
import shallowEqual from 'react-pure-render/shallowEqual';
import has from 'lodash/has';

import Loading from 'components/common/Loading';
import EventEdit from 'components/calendar/EventEdit';

class EventEditPage extends PureComponent {
  static loadData(props) {
    const { event_id } = props;
    props.loadEventForEdit(event_id, { onError: (error) => {
      if (has(error, 'error_msgs[0]')) {
        props.setFlashMessage(error.error_msgs.join('. '), 'error');
        setTimeout(() => props.removeFlashMessage(), 5000);
        props.push('/calendar');
      }
    } });
  }

  static updateHeader(props) {
    const { event_id } = props;
    props.setHeader('Edit Event', false, '', <Link to={`/calendar/details/${event_id}`}>Cancel</Link>);
  }

  state = {}

  componentWillMount() {
    EventEditPage.loadData(this.props);
    EventEditPage.updateHeader(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.event_id && nextProps.event_id !== this.props.event_id) {
      EventEditPage.loadData(nextProps);
    }

    if (nextProps.event && !shallowEqual(nextProps.event, this.props.event)) {
      this.props.resetEventConflictChecks(nextProps.event);
      EventEditPage.updateHeader(nextProps);
    }
  }

  render() {
    const { event } = this.props;

    if (!event || !event.config) {
      return (
        <Loading withWrapper />
      );
    }

    return (
      <EventEdit event={event} />
    );
  }
}

function mapStateToProps(state) {
  const { event_id } = state.router.params;
  const event = has(state.editEvent.events, event_id) ? state.editEvent.events[event_id] : { event_id };
  const { pathname } = state.router.location;

  return {
    event_id,
    event,
    pathname,
  };
}

export default connect(mapStateToProps, {
  loadEventForEdit,
  setHeader,
  resetEventConflictChecks,
  setFlashMessage,
  removeFlashMessage,
  push,
})(EventEditPage);



// WEBPACK FOOTER //
// ./src/app/containers/EventEditPage.js